// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kbArticleSurveyFeedbackWrittenFeedback__writtenFeedbackLabel___1RFjZ{font-weight:bold;margin-bottom:10px;display:block}.kbArticleSurveyFeedbackWrittenFeedback__writtenFeedbackWrapper___1RV-l{width:100%}.kbArticleSurveyFeedbackWrittenFeedback__textArea___6acD7{height:90px;width:100%;border-radius:8px;padding:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "calc(100% - 30px)",
	"widgetFrameMaxHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"writtenFeedbackLabel": "kbArticleSurveyFeedbackWrittenFeedback__writtenFeedbackLabel___1RFjZ",
	"writtenFeedbackWrapper": "kbArticleSurveyFeedbackWrittenFeedback__writtenFeedbackWrapper___1RV-l",
	"textArea": "kbArticleSurveyFeedbackWrittenFeedback__textArea___6acD7"
};
export default ___CSS_LOADER_EXPORT___;
